// @flow
// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  addGtmEvent: ['action', 'label', 'value'],
  setGtmPageView: ['page', 'title'],
})

export const GTMTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  gtmEvents: [],
  gtmPageView: {},
})

/* ------------- Reducers ------------- */

const addGtmEventR = (state, { action, label, value = 'unknown value' }) => {
  const gtmEvents = state.gtmEvents.asMutable()
  gtmEvents.push({
    eventAction: action,
    eventLabel: label,
    eventValue: value
  })
  return state.merge({ gtmEvents })
}

const setGtmPageViewR = (state, { page, title = 'unknown title' }) =>
  state.merge({ gtmPageView: { page, title } })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ADD_GTM_EVENT]: addGtmEventR,
  [Types.SET_GTM_PAGE_VIEW]: setGtmPageViewR,
})
